import { FlightEventHandler, registerEventHandlerClass } from './flight'
import { writable } from 'svelte/store'

export default class LinkStates extends FlightEventHandler {
	linkStates = {}

	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({});
		this.subscribe = subscribe 
		this.set = set
		this.update = update
	}

	handleKeyframe(keyframe) {
		this.linkStates = JSON.parse(JSON.stringify(keyframe.linkStates))
		this.set(this.linkStates)
	}

	handleFlightStep(message) {
		switch(message.type) {
			case "FLIGHT_STATE":
				for (const link of message.flight.links) {
					if (!this.linkStates[link.id]) {
						this.linkStates[link.id] = link
						this.set(this.linkStates)
					}
				}
				break
			case "LINK_UP":
				if (this.linkStates[message.linkId]) {
					this.linkStates[message.linkId].state = "ACTIVE"
					this.set(this.linkStates)
				}
				break
			case "LINK_DOWN":
				if (this.linkStates[message.linkId]) {
					this.linkStates[message.linkId].state = "ENDED"
					this.set(this.linkStates)
				}
				break
		}
	}
}

registerEventHandlerClass(LinkStates)